import api from '../utils/api';

export const getIntegrations = async () => {
  try {
    const response = await api.get('/api/v1/integrations');
    const payload = response?.data;
    return Array.isArray(payload?.data) ? payload.data : [];
  } catch (error) {
    console.error('Failed to fetch integrations:', error);
    return [];
  }
};

export const getIntegrationByName = async (name) => {
  try {
    const response = await api.get('/api/v1/integrations', { params: { name } });
    const payload = response?.data;
    const items = Array.isArray(payload?.data) ? payload.data : [];
    return items[0] || null;
  } catch (error) {
    console.error('Failed to fetch integration by name:', error);
    return null;
  }
};

export const fetchGoogleSheetsData = async (params) => {
  try {
    const { sheet_url, data_range, custom_instruction, actions } = params;
    const queryParams = new URLSearchParams();
    
    if (sheet_url) queryParams.append('sheet_url', sheet_url);
    if (data_range) queryParams.append('data_range', data_range);
    if (custom_instruction) queryParams.append('custom_instruction', custom_instruction);
    if (actions && Array.isArray(actions)) {
      actions.forEach(action => queryParams.append('actions[]', action));
    }
    
    const response = await api.get(`/api/v1/google_sheets/fetch_data?${queryParams.toString()}`);
    return response?.data || null;
  } catch (error) {
    console.error('Failed to fetch Google Sheets data:', error);
    throw error;
  }
};

export const removeIntegration = async (id, name) => {
  try {
    const response = await api.delete(`/api/v1/integrations/${id}`, {
      params: { name }
    });
    return response?.data || null;
  } catch (error) {
    console.error('Failed to remove integration:', error);
    throw error;
  }
};

export const getIntegrationSources = async () => {
  try {
    const response = await api.get('/api/v1/integration_sources');
    const payload = response?.data;
    return Array.isArray(payload?.data) ? payload.data : [];
  } catch (error) {
    console.error('Failed to fetch integration sources:', error);
    return [];
  }
};

export const connectIntegration = async (integrationSourceId, name, fields) => {
  try {
    // Build query parameters: name + all field values
    const params = {
      name: name,
      ...fields
    };
    
    const response = await api.get('/api/v1/verify_integration', {
      params: params
    });
    return response?.data || null;
  } catch (error) {
    console.error('Failed to connect integration:', error);
    throw error;
  }
};

export default {
  getIntegrations,
  getIntegrationByName,
  fetchGoogleSheetsData,
  removeIntegration,
  getIntegrationSources,
  connectIntegration,
};


